import m from '@bitstillery/mithril'
import {$s} from '@/app'

export interface RequireLoginOptions {
    /** Which auth tab to open when not authenticated: 'login' (default) or 'register'. */
    initial_tab?: 'login' | 'register'
}

/**
 * Navigate to `target`, gating behind authentication. When not logged in, route to the
 * auth dialog (login or register tab) carrying `?redirect=<target>` so a successful login
 * continues to the intended destination.
 */
export function require_login(target: string, options?: RequireLoginOptions): void {
    if ($s.identity.token) {
        void m.route.set(target)
    } else {
        const base = options?.initial_tab === 'register' ? '/register' : '/login'
        void m.route.set(`${base}?redirect=${encodeURIComponent(target)}`)
    }
}
